module.exports = __webpack_public_path__ + "img/gather.84fee523.png";